<ion-toolbar [ngClass]="themeClass">
  <ion-grid>
    <ion-row>
      <ion-col size="2">
        <div class="search-icon" (click)="goBack()">
          <ion-icon *ngIf="unlogged && !navigated" class="back-button"  ></ion-icon>
          <ion-icon *ngIf="logged && !navigated" class="back-button-logged" ></ion-icon>
        </div>
      </ion-col>
      <ion-col *ngIf="logged" size="8" class="header-logo-logged">
        <img src="/../assets/img/p-b-logo.png" [ngClass]="{'PB-logo': true, 'hidden': logged}" />
        <div [ngClass]="{'profile': true, 'clear': logged, 'hidden': unlogged}" (click)="goToProfiles()" >
          <div class="profile_image">
            <img *ngIf="!profileAvatar" src="{{this.getDefaultAvatar()}}" class="sophie"/>
            <img *ngIf="profileAvatar" src="{{profileAvatar}}" class="sophie" />
          </div>
          <div class="profile-data">
            <div class="mynews">{{'HEADER.MON_COMPTE' | translate}}</div>
            <div class="profile_name" *ngIf="!getProfileNickName()">
              {{profileName}}
              <img src="/../assets/img/header-arrow-down.png" class="arrow-down" />
            </div>
            <div class="profile_name" *ngIf="getProfileNickName()">
              {{getProfileNickName()}}
              <img src="/../assets/img/header-arrow-down.png" class="arrow-down" />
            </div>
          </div>
        </div>
      </ion-col>
      <ion-col *ngIf="unlogged" size="8" class="header-logo">
        <div [ngClass]="{'PB-logo': true, 'hidden': logged}" (click)="goHome()" ></div>
        <div [ngClass]="{'profile': true, 'clear': logged, 'hidden': unlogged}" (click)="goToProfiles()">
          <div class="profile_image">
            <img *ngIf="!profileAvatar" src="/../assets/img/default_avatar.png" class="sophie" />
            <img *ngIf="profileAvatar" src="/../assets/img/{{profileAvatar}}" class="sophie" />
          </div>
          <div class="mynews">{{'HEADER.MON_COMPTE' | translate}}</div>
          <div class="profile_name">
            {{profileName}}
            <img src="/../assets/img/header-arrow-down.png" class="arrow-down" />
          </div>
        </div>
      </ion-col>
      <ion-col *ngIf="unlogged && themeClass !== 'clfy'" size="2" style="text-align: right" (click)="goToLogin()" >
        <!--       <img *ngIf="this.isPage() !== 'login'" src="/../assets/img/iconarrow-down-copy-2.png" srcset="/../assets/img/iconarrow-down-copy-2@2x.png 2x, /../assets/img/iconarrow-down-copy-2@3x.png 3x" class="" class="" [ngClass]="{'Iconarrow-down-copy-2': true, 'profile-arrow': true, 'hidden': logged}">
      <ion-icon *ngIf="this.isPage() === 'login'" name="closecard"></ion-icon> -->
        <ion-icon class="user"></ion-icon>
      </ion-col>
      <ion-col *ngIf="logged" size="2"> </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>
<ion-item lines="none" [ngClass]="themeClass" *ngIf="unlogged && isPage() !== 'login' && isPage() !== 'create-profile' && themeClass !== 'clfy'" (click)="goToBoutique()" class="BG-Header-copy-2">
  <span class="Sabonner-AUX-JOURNAUX">{{'HEADER.S_ABONNER_AUX_JOURNAUX' | translate}}
    <img class="banner-action-arrow" src="/../assets/img/icon-arrow-abo-copy.png" class="Icon-Arrow-Abo-copy" />
  </span>
</ion-item>
